import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import user from './modules/user';
import * as types from './mutation-type';

Vue.use(Vuex);

export function dateTimeReviver(key, value) {
  let resultRegex;
  if (typeof value === 'string') {
    resultRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (resultRegex) {
      return new Date(value);
    }
  }
  return value;
}

const store = new Vuex.Store({
  state: {
    solde: null,
    nbrSelect: 0,
    maSelection: false,
  },
  getters: {
    getSolde: state => {
      return state.solde;
    },
    getNbrSelect: state => {
      return state.nbrSelect;
    },
    getMaSelection: state => {
      return state.maSelection;
    },
  },
  mutations: {
    ADD(state, data) {
      if (data) {
        state.solde += data;
      } else {
        state.solde += 0;
      }
    },
    SUBSTRACT(state, data) {
      if (data) {
        state.solde -= data;
      } else {
        state.solde -= 0;
      }
    },
    ADD_NBRSELECT(state) {
      state.nbrSelect += 1;
    },
    SUBSTRACT_NBRSELECT(state) {
      state.nbrSelect -= 1;
    },
    SELECTION(state, value) {
      state.maSelection = value;
    },
  },
  actions: {
    add(context, data) {
      context.commit('ADD', data);
    },
    substract(context, data) {
      context.commit('SUBSTRACT', data);
    },
    addNbSelect(context) {
      context.commit('ADD_NBRSELECT');
    },
    substractNbSelect(context) {
      context.commit('SUBSTRACT_NBRSELECT');
    },
    selection(context, value) {
      context.commit('SELECTION', value);
    },
  },
  modules: {
    user,
  },
  plugins: [createPersistedState({
    getState(key, storage) {
      try {
        const localValue = storage.getItem(key);
        let state;
        if (localValue !== 'undefined') {
          state = JSON.parse(localValue, dateTimeReviver);
        }
        return state;
      } catch (err) {
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      }
      return undefined;
    },
    paths: ['user'],
  })],
});

export default store;

export function resetState() {
  ['user'].forEach((module) => {
    store.commit(module + '/' + types.RESET_STATE);
  });
}



// WEBPACK FOOTER //
// ./src/store/store.js